/* tslint:disable */
/* eslint-disable */
/**
 * MTX Brokerage API
 * Brokerage agent-facing API for dispositions, listings, and transactions
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PublicUpdateOfferRequest
 */
export interface PublicUpdateOfferRequest {
    /**
     * 
     * @type {string}
     * @memberof PublicUpdateOfferRequest
     */
    status?: string;
    /**
     * 
     * @type {string}
     * @memberof PublicUpdateOfferRequest
     */
    statusReason?: string;
    /**
     * 
     * @type {string}
     * @memberof PublicUpdateOfferRequest
     */
    additionalComments?: string;
}

/**
 * Check if a given object implements the PublicUpdateOfferRequest interface.
 */
export function instanceOfPublicUpdateOfferRequest(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function PublicUpdateOfferRequestFromJSON(json: any): PublicUpdateOfferRequest {
    return PublicUpdateOfferRequestFromJSONTyped(json, false);
}

export function PublicUpdateOfferRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): PublicUpdateOfferRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': !exists(json, 'status') ? undefined : json['status'],
        'statusReason': !exists(json, 'status_reason') ? undefined : json['status_reason'],
        'additionalComments': !exists(json, 'additional_comments') ? undefined : json['additional_comments'],
    };
}

export function PublicUpdateOfferRequestToJSON(value?: PublicUpdateOfferRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': value.status,
        'status_reason': value.statusReason,
        'additional_comments': value.additionalComments,
    };
}

